import React, { useState, useEffect } from 'react';
import '../../VendorStyles/Preparing.css';
import axiosVendorInstance from '../../axiosVendorInstance';

import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Loader from '../../Components/Loader/Loader';

import { OrderContextuseOrders } from '../../ordersCount';
import { useNotifications } from '../User/Notification/NotificationContext';
import axiosUserInstance from '../../axiosUserInstance';

function Preparing() {
    //const { addNotification } = useNotifications();
    const { addNotification } =useNotifications();
    const { preparingCount, setPreparingCount } = OrderContextuseOrders();

    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [orders, setOrders] = useState([]);
    const pageSize = 10;
    const [vendorID, setVendorID] = useState();

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const fetchVendorID = async () => {
        try {
            setLoading(true);
            const vendorResponse = await axiosVendorInstance.get('/vendors/account');
            setVendorID(vendorResponse?.data?.getVendorInfo[0]?.ID);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching vendor ID:', error);
            setLoading(false);
        }
    };

    const fetchNewOrders = async () => {
        if (!vendorID) return;

        setLoading(true);
        try {
            const response = await axiosVendorInstance.get(
                `/Order/vendor/${vendorID}?pageSize=${pageSize}&pageNumber=${page}&statusId=2`
            );

            const incomingData = response?.data?.allOrdersDetails;

            if (incomingData?.length === 0 && page > 1) {
                setPage(page - 1);
            } else {
                setOrders(incomingData);
                setTotalPages(response?.data?.totalPages || 1);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!vendorID) {
            fetchVendorID();
        }
    }, []);

    useEffect(() => {
        if (vendorID) {
            fetchNewOrders();
        }
    }, [page, vendorID]);

    const handlePushToPickup = async (order) => {
        try {
            const vendorResponse = await axiosVendorInstance.get(
                `/Order/vendor/particularordersdetail/${order?.ID}`
            );
            const userId = vendorResponse?.data?.order?.user_id;

            if (!userId) {
                console.warn('User ID not found for order:', order?.ID);
                return;
            }

            let nextStatusId;
            if (order?.Order_type_id === 1) {
                nextStatusId = 5; // Self Pickup → In Transit
                
            } else if (order?.Order_type_id === 2) {
                nextStatusId = 5; // Delivery → In Transit
            } else {
                console.warn(`Unknown order type for order ${order?.ID}:`, order?.Order_type_id);
                return;
            }

            await axiosVendorInstance.put(
                `/Order/Vendor/${vendorID}/order/${order?.ID}/status`,
                { status_id: nextStatusId }
            );

            setOrders(orders.filter((o) => o.ID !== order?.ID));
            const notificationPayload = {
                from_user_id: userId, // Using the fetched user_id directly
                to_user_id: order.ID, // Assuming this is the right field for recipient
                type: 'order_picked_up',
                action_id: order.ID,
                notification_boundary: 'private',
                is_read: false,
            };

            console.log('Notification payload:', notificationPayload);

            // Assuming you have a function `addNotification` to handle the notification
            addNotification(notificationPayload);
            setPreparingCount(preparingCount - 1);

            // Shipday dummy order (hardcoded for now)
            const items = order?.order_info?.map(info => ({
                name: info?.menu_item?.item_name || 'Unknown Item',
                unitPrice: parseFloat(info?.Price),
                quantity: info?.Quantity,
                addOns: info?.Instructions ? [info?.Instructions] : [],
                detail: info?.Description?.replace(/<\/?[^>]+(>|$)/g, '') || ''
            }));    
              
            const shipdayOrderData = {
                orderId: `${order?.ID}`,
                customerId:`${order?.user?.ID}`,
                customerName: `${order?.user?.first_name || 'N/A'} ${order.user?.last_name || ''}`.trim(),
                customerAddress: '123 Main St, San Francisco, CA 94110',
                customerEmail: 'john.doe@example.com',
                customerPhone: '+14155552345',
                restaurantName: 'Pizza Place',
                restaurantAddress: '456 Pizza St, San Francisco, CA 94110',
                restaurantPhone: '+14155553210',
                totalCost: 45.0,
                pickupLat: 37.7749,
                pickupLng: -122.4194,
                deliveryLat: 37.7849,
                deliveryLng: -122.4094,
                deliveryDate: '2025-04-30',
                deliveryTime: '14:00:00',
                pickupTime: '13:30:00',
                items: items
            };
              
            
            await axiosUserInstance.post(
                '/shipday/create',
                shipdayOrderData
            );
            
        } catch (error) {
            console.error('Error updating order status:', error);
        }
        fetchNewOrders();
    };

    return (
        <div className="new-orders-main">
            {loading ? (
                <Loader />
            ) : (
                <div>
                    {orders && orders?.length > 0 ? (
                        orders?.map((order) => {
                            const createdAt = new Date(order.Created_at);
                            const time = createdAt.toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            });
                            const date = `${createdAt.getDate()} ${createdAt.toLocaleString(
                                'en-US',
                                { month: 'short' }
                            )}`;

                            return (
                                <div key={order.ID} className="single-order">
                                    <div className="orderid">
                                        <p className="order-details1">
                                            Order ID: <span className="order-id">{order.ID}</span>
                                        </p>
                                    </div>
                                    <div className="date-and-time">
                                        <p className="order-details2">{time}</p>
                                        <p className="order-details3">{date}</p>
                                    </div>
                                    <button
                                        className="push-to-pickup-btn"
                                        onClick={() => handlePushToPickup(order)}
                                    >
                                        <p className="push-to-pickup-text">
                                            Ready For Pickup
                                        </p>
                                    </button>
                                </div>
                            );
                        })
                    ) : 
                        <div className="no-data-message">No data</div>
                    }

                    {orders?.length > 0 && totalPages > 1 && (
                        <div className="pagination-container">
                            <Stack spacing={2}>
                                <Pagination
                                    sx={{
                                        '& .MuiPagination-ul': {
                                            color: '#333',
                                            padding: 1,
                                            borderRadius: 2,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            listStyleType: 'none',
                                        },
                                    }}
                                    count={totalPages}
                                    page={page}
                                    onChange={handlePageChange}
                                    showFirstButton
                                    showLastButton
                                />
                            </Stack>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default Preparing;
